module.exports = __webpack_public_path__ + "img/logo.995432a2.png";